import { Order } from '@multitec/domain/src/schemas'
import { useQuery } from 'react-query'
import { z } from 'zod'

import { apiConn } from '@/services/api/connector'

import { Cliente } from '../domain/cliente'
import { Equipamento } from '../domain/equipamento'
import { Evidencia } from '../domain/evidencia'
import { Item } from '../domain/item'
import { Ordem } from '../domain/ordem'

export const OrdemService = {
  fetchOrdensBloqueadas() {
    return useQuery(['ordens', 'fetch-bloqueadas'], async () => {
      const {
        data: { result },
      } = await apiConn.get('entity/orders/bloqueadas')

      return z
        .array(
          Order.extend({
            OrderReport: z.array(z.object({ description: z.string() })),
          }),
        )
        .parse(result)
    })
  },

  fetchOrdensPatrimonio(id: string) {
    return useQuery(['ordens', 'fetch-patrimonio', { id }], async () => {
      const {
        data: { result },
      } = await apiConn.get('entity/orders/patrimonio?id=' + id)

      return z.array(Order).parse(result)
    })
  },

  getPublicOrdemView(hashId: string | undefined) {
    return useQuery(['publico-ordem', { hashId }], async () => {
      if (!hashId) return null

      const {
        data: { data },
      } = await apiConn.get(`publico/ordem/${hashId}`)

      return {
        ordem: new Ordem({
          ...data.ordem,
          abertaEm: new Date(data.ordem.abertaEm),
          aprovadoEm: data.ordem.aprovadoEm
            ? new Date(data.ordem.aprovadoEm)
            : null,
          entregaEm: data.ordem.entregaEm
            ? new Date(
                data.ordem.entregaEm.replace(
                  'T00:00:00.000Z',
                  'T03:00:00.000Z',
                ),
              )
            : null,
        }),
        cliente: new Cliente(data.cliente),
        equipamento: new Equipamento(data.equipamento),
        evidencias: data.evidencias.map((e: any) => new Evidencia(e)),
        itens: data.itens.map((i: any) => new Item(i)),
      }
    })
  },

  fetchOrdensPainel() {
    return useQuery(['ordens', 'fetch-painel'], async () => {
      const {
        data: { result },
      } = await apiConn.get('publico/ordem/')

      console.log(result)

      const ordensSchema = z.object({
        ordens: z.array(z.any()),
      })

      const ordensResult = ordensSchema.parse(result)

      return ordensResult.ordens.map((res: any) => {
        return new Ordem({
          id: res.id,
          clienteNome: res.clienteNome,
          equipamentoNome: res.equipamentoNome,
          abertaEm: new Date(res.abertaEm),
          aprovadoEm: res.aprovadoEm ? new Date(res.aprovadoEm) : null,
          entregaEm: res.entregaEm ? new Date(res.entregaEm) : null,
          defeitoReclamado: res.defeitoReclamado,
          defeitoConstatado: res.defeitoConstatado,
          condicaoPgto: res.condicaoPgto,
          status: res.status,
          observacao: res.observacao,
          tipoBloqueio: res.tipoBloqueio,
        })
      })
    })
  },
}
